import { authGuard, permissionGuard } from '@abp/ng.core';
import { Routes } from '@angular/router';

export const APP_ROUTES: Routes = [
  {
    path: '',
    pathMatch: 'full',
    title: 'Home',
    loadComponent: () => import('./home/home.component').then(c => c.HomeComponent),
    // 20251107RBP - The site should be locked down to only logged in users
    canActivate: [authGuard],
  },
  {
    path: 'dashboard',
    loadComponent: () => import('./dashboard/dashboard.component').then(c => c.DashboardComponent),
    canActivate: [authGuard, permissionGuard],
  },
  {
    path: 'account',
    loadChildren: () => import('@volo/abp.ng.account/public').then(c => c.createRoutes()),
  },
  {
    path: 'gdpr',
    loadChildren: () => import('@volo/abp.ng.gdpr').then(c => c.createRoutes()),
  },
  {
    path: 'identity',
    loadChildren: () => import('@volo/abp.ng.identity').then(c => c.createRoutes()),
  },
  {
    path: 'language-management',
    loadChildren: () => import('@volo/abp.ng.language-management').then(c => c.createRoutes()),
  },
  {
    path: 'saas',
    loadChildren: () => import('@volo/abp.ng.saas').then(c => c.createRoutes()),
  },
  {
    path: 'audit-logs',
    loadChildren: () => import('@volo/abp.ng.audit-logging').then(c => c.createRoutes()),
  },
  {
    path: 'openiddict',
    loadChildren: () => import('@volo/abp.ng.openiddictpro').then(c => c.createRoutes()),
  },
  {
    path: 'text-template-management',
    loadChildren: () => import('@volo/abp.ng.text-template-management').then(c => c.createRoutes()),
  },
  {
    path: 'setting-management',
    loadChildren: () => import('@abp/ng.setting-management').then(c => c.createRoutes()),
  },
  {
    path: 'gdpr-cookie-consent',
    children: [
      {
        path: 'privacy',
        loadComponent: () =>
          import('./gdpr-cookie-consent/privacy-policy.component').then(
            c => c.PrivacyPolicyComponent
          ),
      },
      {
        path: 'cookie',
        loadComponent: () =>
          import('./gdpr-cookie-consent/cookie-policy.component').then(
            c => c.CookiePolicyComponent
          ),
      },
    ],
  },
  {
    path: 'books',
    loadComponent: () => import('./book/book.component').then(c => c.BookComponent),
    canActivate: [authGuard, permissionGuard],
  },
  {
    path: 'faculty-profile',
    title: 'Faculty Profile',
    loadComponent: () => import('./faculty-profile/faculty-profile.component').then(c => c.FacultyProfileComponent),
    canActivate: [authGuard, permissionGuard],
  },
   {
    path: 'faculty-profile/edit',
    title: 'Faculty Profile Edit',
    loadComponent: () => import('./faculty-profile/edit-faculty/edit-faculty-profile.component').then(c => c.EditFacultyProfileComponent),
    canActivate: [authGuard, permissionGuard],
  },
  {
    path: 'faculty-management',
    title: 'Faculty Management',
    loadComponent: () => import('./faculty-management/faculty-management.component').then(c => c.FacultyManagementComponent),
    canActivate: [authGuard, permissionGuard],
  },
  {
    path: 'affiliations-management',
    title: 'Affiliations Management',
    loadComponent: () => import('./affiliations-management/affiliations-management.component').then(c => c.AffiliationsManagementComponent),
    canActivate: [authGuard],
  },
  {
    path: 'affiliations-management/edit',
    title: 'Affiliation',
    loadComponent: () => import('./affiliations-management/edit-affiliation/edit-affiliation.component').then(c => c.EditAffiliationComponent),
    canActivate: [authGuard],
},
  {
    path: 'events-management/new',
    title: 'Create Event',
    loadComponent: () => import('./events-management/edit-event/edit-event.component').then(c => c.EditEventComponent),
    canActivate: [authGuard, permissionGuard],
  },
  {
    path: 'events-management/edit/:id',
    title: 'Edit Event',
    loadComponent: () => import('./events-management/edit-event/edit-event.component').then(c => c.EditEventComponent),
    canActivate: [authGuard, permissionGuard],
  },
  {
    path: 'events-management',
    title: 'Events Management',
    loadComponent: () => import('./events-management/events-management.component').then(c => c.EventsManagementComponent),
    canActivate: [authGuard, permissionGuard],
  },
];
